export function getHighestLevelWithPrefix(problems, prefix, useDisplay = false) {
  if ((problems?.length ?? 0) === 0) return "";

  let knownLevel = "";

  for (let i = 0; i < problems.length; i++) {
    if (!(problems[i]?.field ?? "").startsWith(prefix)) continue;
    switch (useDisplay ? (problems[i].displayLevel ?? problems[i].level) : problems[i].level) {
      case "error":
        // If we find an error, just return
        return "error";
      case "warning":
        knownLevel = "warning";
        break;
      case "incomplete":
        if (knownLevel !== "warning") {
          knownLevel = "incomplete";
        }
        break;
      default:
        break;
    }
  }

  return knownLevel;
}
